module.exports = __webpack_public_path__ + "media/images/sp/top/title-1d7b64b3e315fef23d7e86f74cf07a0f.png";